import { assign } from 'xstate';
import { solarMachine } from '~/machines/solar-funnel';
import { utilityMachine } from '~/machines/utility-selection';
import { LDClient } from '~/providers';
import { OriginationSource } from '~/typings/graphql';
import { getInitialState } from '~/utils/funnels';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    enrollment: {
      context: {
        canSkipUtilityConnect: true,
      },
    },
    user: {
      context: {
        originationSource: OriginationSource.DirectSales,
      },
    },
  }).withConfig({
    actions: {
      // skipping utility connect should still be treated as selecting it as the enrollment source
      setEnrollmentSelection: assign((_context, event) => {
        const { enrollmentSelection } = event.data;
        return enrollmentSelection === 'none'
          ? { enrollmentSelection: 'utility_connect' }
          : { enrollmentSelection };
      }),
    },
    services: {
      utilityMachine: utilityMachine().withConfig({
        guards: {
          shouldShowFriction: context => {
            const allowedUtilities = LDClient.variation('conference-funnel-utilities');
            return !allowedUtilities.includes(context.utilityId);
          },
        },
      }),
    },
  });
